import { Plugin } from "@ckeditor/ckeditor5-core";
import ApplyTemplateCommand from "./ApplyTemplateCommand";
export default class ApplyTemplateEditing extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add("applyTemplate", new ApplyTemplateCommand(editor));

    if (editor.plugins.has("TrackChangesEditing")) {
      const trackChangesEditing = editor.plugins.get("TrackChangesEditing");
      trackChangesEditing.enableCommand("applyTemplate");
    }
  }
}
